<template>
    <div class="page my-amount">

        <div class="my-amount-header">
            <div class="my-amount-header-title">我的账户 <span class="my-amount-header-title-right" @click="$router.push({name:'amount-rule'})">获得博贝规则 <img src="/static/img/icon_mycenter_rule.png" alt=""></span></div>
            <div class="my-amount-header-point"><span class="my-amount-header-point-amount">{{user.point}}</span> 博贝</div>
        </div>

        <div class="my-amount-content">
            <van-tabs :swipeable="true" :border="true" animated v-model="tab">
                <van-tab :title="'获得博贝'" class="my-amount-intro" :title-style="'text-align:right'">
                    <van-cell is-link v-for="item in income" :key="item.id">
                        <template slot="title">
                            <div class="my-amount-content-title">{{item.note}}</div>
                            <div class="my-amount-content-time">{{item.created_at}}</div>
                        </template>
                        <template slot="right-icon">
                            <div class="my-amount-content-point">+{{item.value}}</div>
                        </template>
                    </van-cell>
                </van-tab>
                <van-tab :title="'消耗博贝'" class="my-amount-common">
                    <van-cell title-class="control-title" is-link v-for="item in outcome" :key="item.id">
                        <template slot="title">
                            <div class="my-amount-content-title">{{item.note}}</div>
                            <div class="my-amount-content-time">{{item.created_at}}</div>
                        </template>
                        <template slot="right-icon">
                            <div class="my-amount-content-point">-{{item.value}}</div>
                        </template>
                    </van-cell>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                income:[],
                outcome:[],
                user:{},
                tab:0
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'income') {
                    Interface.getData('get',Interface.user.point,{type:'income',pageSize:999}).then((res)=>{
                        this.income = res.data.list
                    })
                }else if (scene === 'outcome') {
                    Interface.getData('get',Interface.user.point,{type:'outcome',pageSize:999}).then((res)=>{
                        this.outcome = res.data.list
                    })
                }else if (scene === 'userinfo') {
                    Interface.getData('get',Interface.user.user_info).then((res)=>{
                        this.user = res.data
                    })
                }
            }
        },
        created() {
            this.fetch('income')
            this.fetch('outcome')
            this.fetch('userinfo')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/amount/index.vue